import { render, staticRenderFns } from "./form-switch.vue?vue&type=template&id=57526c59&scoped=true&"
import script from "./form-switch.vue?vue&type=script&lang=js&"
export * from "./form-switch.vue?vue&type=script&lang=js&"
import style0 from "./form-switch.vue?vue&type=style&index=0&id=57526c59&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57526c59",
  null
  
)

export default component.exports